import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=30cc2c94&"
import script from "./Truck.vue?vue&type=script&lang=js&"
export * from "./Truck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports